import React from 'react';
import styled from 'styled-components';
import { ResponsiveEmbed } from 'react-bootstrap';

const StyledDiv = styled.div`
    border-style: solid;
    border-color: white;
    border-width: 2px;
`;

const YoutubeVideo = (props) => (
    <StyledDiv>
        <ResponsiveEmbed a16by9>
            <iframe title={props.title} src={props.url + '?autohide=1&showinfo=0&controls=0&modestbranding=1&rel=0'}></iframe>
        </ResponsiveEmbed>
    </StyledDiv>
);

export default YoutubeVideo;


// WEBPACK FOOTER //
// ./src/components/UI/YoutubeVideo/YoutubeVideo.js